import React,{useState,useEffect,useCallback} from 'react';
import DataTable from 'react-data-table-component-footer';
import * as RestService from '../../services/eisRest';
import { Button} from 'react-bootstrap';

import FileSaver from 'file-saver';

import LoadingOverlay from 'react-loading-overlay';
import {useTranslation} from 'react-i18next';
import * as moment from 'moment';
import 'moment/locale/sk';

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

const DataTableAttendanceDetail = (props) => {

    const [t] = useTranslation();      
    const [url, setUrl] = useState();
    const [urlExcel, setUrlExcel] = useState();


    const [data, setData] = useState();
  //  const [columns, setColumns] = useState(props.columns);
    const [columnsData, setColumnsData] = useState(props.columnsData);
    const [loading, setLoading] = useState(false);
    const [exportRunning, setExportRunning] = useState(false);    
//    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(40);
    const [currentPage, setCurrentPage] = useState(1);    
    const [selectedColumn] = useState(0);    
    const [sortDirection] = useState('asc');        
    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);        
  //  const [modalShow, setModalShow] = useState(props.modalShow);
  //  const [checkTime, setCheckTime] = useState(null);
   

    const customStyles = {
      rows: {
        style: {
        //  fontFamily: "Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif",
          fontSize: '15px'
        }        
      },
      header: {
        style: {
          fontSize: '22px',
          fontWeight: 800
        },
      },     
      headCells: {
        style: {
          fontSize: '17px',
          fontWeight: 800
          
        },
      }
    };


 
    const fetchData = (url,page, size = perPage, selectedColumn = 1, sortDirection = 'asc', search = '') => {
        if(typeof url=== 'undefined'){return;}
        setLoading(true);          
             
        RestService.callAnyApi(url,{
            columns: props.columnsData,
            order: [{column: selectedColumn,dir: sortDirection}],
            search: {value: search,regex: false},
            draw: page-1,
            length: size,
            start: ((page-1)*size)          
        })
          .then((response) => {          
                  
            if(typeof(response) !== 'undefined'){
              setData(response.data);
            }else{
              setData([{}]);  
            }
            
          //  setTotalRows(response.recordsFiltered);
            setLoading(false);
          })
          .catch((error) => {               
            console.log(error)
            setLoading(false);
            setData([{}]);
          });
    
       
      };

     
     
      const callFetchData  = useCallback(() => {    
        fetchData(url,currentPage,perPage,selectedColumn,sortDirection,filterText);
      }, [fetchData,url,currentPage,perPage,selectedColumn,sortDirection,filterText]);
    
  
      useEffect(() => {
        //callFetchData();
        fetchData(props.url,currentPage,perPage,selectedColumn,sortDirection,filterText);
      }, [props.checkTime]);
    

  //    useEffect(() => {
  //      callFetchData();
  //    }, [callFetchData,props.modalShow]);
    

      useEffect(() => {
          setUrl(props.url);
          //callFetchData();
          fetchData(props.url,currentPage,perPage,selectedColumn,sortDirection,filterText);
      }, [props.url]);
    
      useEffect(() => {
        setUrlExcel(props.urlExcel);        
    }, [props.urlExcel]);

    useEffect(() => {
      setColumnsData(props.columnsData);        
  }, [props.columnsData]);
    
    
      const handleRowClicked = (row) =>{
        //console.log(row);
        props.parentCallback(row.id); 
      }


      const exportExcel = () =>{
        setExportRunning(true);       
        RestService.downloadExceFile(urlExcel,{
              columns: columnsData,
              order: [{column: selectedColumn,dir: sortDirection}],
              search: {value: filterText,regex: false},
              draw: currentPage-1,
              length: perPage,
              start: ((currentPage-1)*perPage)          
        })          
        .then((response) => {       
           //FileDownload(response.data, 'report.xls');   

           //console.log(response.headers);
           const filename = response.headers['content-disposition']
           
           //const filename = obj.Get('content-disposition');
           //const filename = ""; //response.headers.json(); // .headers .get('content-disposition')           
         //  const z = filename.content-disposition;
           .split(';')
           .find(n => n.includes('filename='))
           .replace('filename=', '')
           .trim()
         ;
     
         //const blob = await response.blob();

           FileSaver.saveAs(response.data,filename);//, 'report.xlsx'
           setExportRunning(false);       
           // console.log(response);
        })
        .catch((error) => {               
          console.log(error);
          setExportRunning(false);       
        });               

    };


      const conditionalRowStyles = [
        {
          when: row => row.weekend ,
          style: {
            color: "red",
            userSelect: "none"
          }
        }
      ];

   

      const getHours = (value) => {
        if(value==null){
            return '';
        }else{
            return moment.duration(value,'milliseconds').format('HH:mm',{trim: false });
        }
    }

      const sumWorkTotal = (part) => {
        let x = 0;
        if(data){
        data.map((item) => {
          switch(part){
            case "sumWork":
              x += item.sumWork;
            break;
            case "sumLunch":
              x += item.sumLunch;
            break;
            case "sumDoctor":
              x += item.sumDoctor;
            break;
            case "sumDoctorWithFamily":
              x += item.sumDoctorWithFamily;
            break;
            case "sumHoliday":
              x += item.sumHoliday;
            break;
            case "sumBusinessTrip":
              x += item.sumBusinessTrip;
            break;
            case "sumOther":
              x += item.sumOther;
            break;
            case "saldo":
              x += item.saldo;
            break;
            case "saldoDiff":
              x += item.saldoDiff;
            break;
          }
          
          return x;
        });
      }      
        return getHours(x);
      };

      const footerObject =  {
        
        date: "",
        sumWorkText: sumWorkTotal("sumWork"),
        sumLunchText: sumWorkTotal("sumLunch"),
        sumDoctorText: sumWorkTotal("sumDoctor"),
        sumDoctorWithFamilyText: sumWorkTotal("sumDoctorWithFamily"),
        sumHolidayText: sumWorkTotal("sumHoliday"),
        sumBusinessTripText: sumWorkTotal("sumBusinessTrip"),
        sumOtherText: sumWorkTotal("sumOther"),
        saldoText: sumWorkTotal("saldo"),
        saldoDiffText: sumWorkTotal("saldoDiff")



        
      };

    

      const ExportComponent = () => {
       
        return(
                                
                  
                        <div>
                          <Button className="btn-default" style={{marginLeft: '10px'}} onClick={exportExcel}>Export to Excel 
                              <i className="fas fa-file-excel" style={{marginLeft: '10px'}}></i>
                          </Button>
                        </div>
                 
                                          
            
        );

      };


      const subHeaderComponentMemo = React.useMemo(() => {
       
        return (
                  <>                   
                  <ExportComponent urlExcel={urlExcel} columnsData={columnsData}/>
                  </>
               );
      }, [urlExcel,columnsData]);


      const ExpanableComponent = ({ data, subColumns}) => {             
        return (
                    <DataTable    
                        data={data ? data.attendanceEventList : []}
                        noHeader={true}                                              
                        subHeader={false}                                                
                        columns={subColumns}
                    />
              );
        };

        return (
          <>
         <LoadingOverlay
  active={exportRunning}
  spinner
  text='Export running...'
  >
  <DataTable
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              //  subHeader={false}
               fixedHeader
               fixedHeaderScrollHeight="500px"
            //    footerBold={true}
              //  footer={footerObject}
            //    title={subHeaderSumary}
                columns={props.columns}
                data={data}                
                progressPending={loading}
                //pagination
                //paginationServer
                sortServer         
              //  paginationTotalRows={totalRows}
              //  paginationDefaultPage={currentPage}
              //  onChangeRowsPerPage={handlePerRowsChange}
              //  onChangePage={handlePageChange}
               // onSort={handleOnSort}              
               // selectableRows
                highlightOnHover
                onRowClicked={handleRowClicked}                
                onSelectedRowsChange={({ selectedRows }) => console.log(selectedRows)}
                paginationResetDefaultPage={resetPaginationToggle} 
                customStyles={customStyles}
                dense
                expandableRows={props.expandableRows}
                expandableRowsComponent={
                  <ExpanableComponent subColumns={props.columnsSubRow}/>
                } 
                conditionalRowStyles={conditionalRowStyles}
                footer={footerObject}               
                />
</LoadingOverlay>
                
                  
          </>

          
        );
}

export default DataTableAttendanceDetail;